import React from 'react';
import { Logo } from './Logo';
import { HeroContent } from './HeroContent';

export const HeroSection = () => {
  const heroStyles = {
    position: 'relative',
    width: '100%',
    height: '838px',
    overflow: 'hidden'
  };

  const backgroundStyles = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 1
  };

  const contentStyles = {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    maxWidth: '1200px',
    padding: '2rem 1.25rem',
    zIndex: 2
  };

  return (
    <section style={heroStyles}>
      <img
        src="https://api.builder.io/api/v1/image/assets/TEMP/358bac338e5ea73f796f642e76a1e43ba388ef57?width=2880"
        alt=""
        style={backgroundStyles}
      />

      <div style={contentStyles}>
        <div className="d-flex flex-column align-items-center">
          <Logo />
          <HeroContent />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
